// janetTopics — PURE helpers for Janet chat topics (no Supabase import, so
// tests and the api/ side can use them without constructing a client).
// The hooks (useJanetSessions / useJanetMemory) import from here.

const TITLE_MAX = 80

export function newSessionId() {
  return typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `sess-${Date.now()}`
}

// First user turn → topic title. Plain, trimmed, no trailing punctuation.
export function deriveTitle(text) {
  const t = String(text || '').replace(/\s+/g, ' ').trim()
  if (!t) return null
  const cut = t.length > TITLE_MAX ? t.slice(0, TITLE_MAX).replace(/\s+\S*$/, '') + '…' : t
  return cut.replace(/[.!?,;:]+$/, '') || cut
}

// Card payloads a resumed topic needs to redraw its actionable cards.
// `personalMail` isn't a card — it's a security flag (personal-mail.js
// sanitizeHistoryForVoice) marking a turn that drew on personal iCloud mail —
// but it rides this exact same JSONB round-trip so a RESUMED topic (after a
// reload) still redacts that turn out of a later voice-mode request's
// history, not just a live one.
export const CARD_KEYS = ['queuedDraft', 'draftPayload', 'taskPayload', 'calendarPayload', 'calendarResult', 'callPayload', 'scheduleProposalPayload', 'schedulingPayload', 'taskCreated', 'contextPayload', 'designPayload', 'openerPayload', 'personalMail', 'resolvedContacts', 'sourcesPayload', 'sourcesUnavailable']

export function pickCardPayload(msg) {
  const out = {}
  for (const k of CARD_KEYS) if (msg?.[k] != null) out[k] = msg[k]
  return Object.keys(out).length ? out : null
}

// Durable Engineering references use the existing JSONB payload round-trip.
CARD_KEYS.push('engineeringWork', 'engineeringRequestId')
// Janet's heads-ups (the Today thread): category and the source links shown as chips.
CARD_KEYS.push('headsUp')
